import React from "react";
import { useSelector } from "react-redux";
import { Text, InfoProgressBar } from "@components";
import bookingBGImage from "@assets/images/bookingRules.png";
import "./ruleBox.css";

const RuleBox = ({ rule }) => {
  const { name, rules } = rule;
  const { setting } = useSelector((store) => store.settingsReducer);

  return (
    <div className="shadow-[0_0px_15px_0px_#cdcaec] rounded-md">
      <InfoProgressBar />
      {rules?.length > 0 ? (
        <div
          className="px-4 w-full bg-white h-auto min-h-[250px] rounded-b-lg object-cover"
          style={{
            backgroundImage: `url(${bookingBGImage})`,
            backgroundSize: "cover",
          }}
        >
          <div className="w-full h-full flex bg-transparent flex-row justify-between items-center">
            <div className="xl:w-[75%] w-full h-full flex md2:flex-row md2:flex-wrap flex-col  items-start md2:justify-between justify-start gap-x-4 gap-y-5 py-4">
              <div className="md2:w-[45%] w-full h-auto">
                <div className="bg-gradient-to-r from-buttonDarkColor to-buttonColor text-white font-bold text-[18px] text-center px-4 flex items-center justify-center rounded-r-full rounded-t-full w-fit min-w-[240px] h-auto min-h-[50px]">
                  {name}
                </div>
              </div>
              {rules?.filter((_, idx) => idx !== 4)?.map((item, index) => (
                <div
                  key={index}
                  className="md2:w-[45%] w-full h-auto flex flex-col items-start justify-start gap-y-2"
                >
                  <Text className="text-buttonColor font-semibold text-[16px]">
                    {item?.title}
                  </Text>
                  <Text className="text-[16px] text-start text-base/6 leading-5">
                    {item?.description}
                  </Text>
                </div>
              ))}
            </div>
            <div className="w-[25%] h-full xl:flex hidden items-end justify-end">
              <img
                src={setting?.data?.bookingRulesImage?.url}
                className={`w-auto max-w-[255px] h-[219px] `}
              />
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default RuleBox;
